import EndorsementChainType from './endorsement-chain-type/index.js';

const RENDERER_URL = {
	local: 'https://renderer.dev.sgtradex.io',
	dev: 'https://renderer.dev.sgtradex.io',
	test: 'https://renderer.test.sgtradex.io',
	uat: 'https://renderer.uat.sgtradex.io',
	"pre-prod": 'https://renderer.pre-prod.sgtradex.io',
	prod: 'https://renderer.sgtradex.io',
};

const getDefaultRendererUrl = (env) => {
	return RENDERER_URL?.[env] ?? RENDERER_URL.prod;
}

export { etrActions, etrActionable } from './etr-action/index.js';
export { EndorsementChainType, getDefaultRendererUrl, RENDERER_URL };
